class DiagPreo {
    constructor(element, options = {}){
        this.options = Object.assign(
            {},
            {    
                preoccupation: "",
                peau : "",
                products : {},
                selectionMax : 5,
                preo_desc: "",
                offer: false
            }, 
            options
        );   

        this.diag = element;
        this.currentStep = 1;
        this.productsSelected = [];
        this.preoccupations = element.querySelectorAll(".preoccupations .preoccupation");
        this.diffContent = element.querySelector(".diff");
        this.peaux = element.querySelectorAll(".peaux .peau");
        this.recos = element.querySelector(".recommendations .products");
        this.selections = element.querySelectorAll(".content-selection .content-products .content-product");
        this.selectionsRemoveBtn = element.querySelectorAll(".content-selection .content-products .content-product .remove");
        this.countSelection = element.querySelector(".prd-count-diff");
        this.addToCart = element.querySelector(".content-selection .add-to-cart");
        this.filters = element.querySelectorAll(".content-filter .filter"); 

        this.descBtnPlus = element.querySelectorAll(".content-descriptions .description .plus"); 

        this.diag.querySelectorAll(".content-back .change").forEach(change => {
            change.addEventListener("click", () => {
                console.log("change");
                change.closest(".content-selector").classList.remove("ok");
                let dataStep = change.closest(".content-selector").getAttribute("data-step");
                if(dataStep == 1){
                    this.currentStep = 1;
                    this.resetStep(2);
                    this.resetStep(3);
                }
                if(dataStep == 2){ 
                    this.currentStep = 2;
                    this.resetStep(3);
                }
            });
        });

        this.descBtnPlus.forEach(btn => {
            btn.addEventListener("click", () => {
                btn.closest(".description").classList.toggle("open");
            })
        });

        if(!this.options.offer){ 
            document.querySelector(".recommendations .diff").classList.add("hide");
        }
  

        this.addToCart.addEventListener("click" , () => {
            let prds = [];
            this.productsSelected.forEach(prd => {
                prds.push(prd.vid);
            });  
            novCart.addItemArray(prds, "", this.addToCart); 
        });
  

        this.selectionsRemoveBtn.forEach(btn => {
            btn.addEventListener("click", () => {
                let dataVid = btn.closest(".content-product").getAttribute("data-vid");  
                let cat = btn.closest(".content-product").getAttribute("data-cat"); 
                this.recos.querySelectorAll(`.product-min[data-vid='${dataVid}'][data-cat='${cat}']`).forEach(p => {p.classList.remove("selected")});
                //this.recos.querySelectorAll(`.product-min[data-vid='${dataVid}']`).forEach(p => {p.classList.remove("selected")});
                if(dataVid != null && dataVid != "" && cat != null && cat != ""){ 
                    const indexToRemove = this.productsSelected.findIndex(prd => prd.vid === parseInt(dataVid) && prd.cat === cat);
                    //const indexToRemove = this.productsSelected.findIndex(prd => prd.vid === parseInt(dataVid));
                    if (indexToRemove !== -1) {
                        this.productsSelected.splice(indexToRemove, 1); 
                    }
                }  
                this.buildSelection(this.productsSelected);
            });
        });  

        document.querySelectorAll(`#preoccupations .preoccupation`).forEach(p => { 
            p.addEventListener("click", () => {
                this.select(p);
            });
        });

        document.querySelectorAll(`#peaux .peau`).forEach(p => { 
            p.addEventListener("click", () => {
                this.select(p);
            });
        });

        document.querySelectorAll(`#categories .categorie`).forEach(c => { 
            c.addEventListener("click", () => {
                let cat = c.getAttribute("data-cat");
                if(document.querySelector(`#preoccupations.ok`)){
                    document.querySelector(`#preoccupations`).classList.remove("ok");
                }
                if(document.querySelector(`#peaux.ok`)){
                    document.querySelector(`#peaux`).classList.remove("ok");
                }
                if(!document.querySelector(`#preoccupations`).classList.contains("hide")){
                    document.querySelector(`#preoccupations`).classList.add("hide");
                }
                if(!document.querySelector(`#peaux`).classList.contains("hide")){
                    document.querySelector(`#peaux`).classList.add("hide");
                }
                document.querySelectorAll(`#peaux .peau.on`).forEach(p => {p.classList.remove("on")});
                document.querySelectorAll(`#preoccupations .preoccupation.on`).forEach(p => {p.classList.remove("on")});
                document.querySelectorAll(`#preoccupations .preoccupation[data-cat='${cat}']`).forEach(p => {
                    p.classList.add("on");  
                    //this.hideStep(0, true, 500);
                    this.goToStep(1); 
                });
                if(document.querySelectorAll(`#preoccupations .preoccupation[data-cat='${cat}']`).length == 1){
                    this.select(document.querySelectorAll(`#preoccupations .preoccupation[data-cat='${cat}']`)[0]);
                };
            });
        });

        if(getParams("cat") != null){
            let cat = getParams("cat");
            this.goToStep(1);
            if(cat == "all"){ 
                document.querySelector(`#preoccupations`).classList.add("all");
                document.querySelectorAll(`#preoccupations .preoccupation`).forEach(p => {
                    p.classList.add("on");   
                });
            }else{ 
                document.querySelectorAll(`#preoccupations .preoccupation[data-cat='${cat}']`).forEach(p => {
                    p.classList.add("on");  
                });
                if(document.querySelectorAll(`#preoccupations .preoccupation[data-cat='${cat}']`).length == 1){
                    this.select(document.querySelectorAll(`#preoccupations .preoccupation[data-cat='${cat}']`)[0]);
                } 
            } 
        }else{
            if(getParams("preo") != null){
                this.goToStep(1);
                if(getParams("peau") != null){
                    this.goToStep(2); 
                    document.querySelector(`#preoccupations .preoccupation[data-value='${getParams("preo")}']`).classList.add("on");
                    this.select(document.querySelector(`#preoccupations .preoccupation[data-value='${getParams("preo")}']`));
                    document.querySelector(`#peaux .peau[data-value='${getParams("peau")}']`).classList.add("on");
                    this.select(document.querySelector(`#peaux .peau[data-value='${getParams("peau")}']`));
                }else{ 
                    document.querySelector(`#preoccupations .preoccupation[data-value='${getParams("preo")}']`).classList.add("on");
                    this.select(document.querySelector(`#preoccupations .preoccupation[data-value='${getParams("preo")}']`)); 
                } 
            }else{
                this.goToStep(0);
            }
        }

        /*
        document.querySelectorAll(`#preoccupations .preoccupation`).forEach(preo => {
            let filterSkin = (/true/).test(preo.getAttribute("data-filtrer-skin"));  
            let value = preo.getAttribute("data-value");
            console.group(value);
                console.log(`https://novexpert-lab.com/pages/diagnostic-preoccupation?preo=${value}`);
                if(filterSkin){
                    console.log(`https://novexpert-lab.com/pages/diagnostic-preoccupation?preo=${value}&peau=peau-grasse`);
                    console.log(`https://novexpert-lab.com/pages/diagnostic-preoccupation?preo=${value}&peau=peau-mixte-normale`);
                    console.log(`https://novexpert-lab.com/pages/diagnostic-preoccupation?preo=${value}&peau=peau-seche`);
                }
            console.groupEnd();
        });
        */

        window.addEventListener("scroll", () => {
            let recoTop = element.querySelector(".content-recommendations").offsetTop; 
            if((window.scrollY + (window.innerHeight*0.5)) >= recoTop){
                if(!element.querySelector(".content-selection").classList.contains("show")){
                    element.querySelector(".content-selection").classList.add("show");
                }
            }else{
                if(element.querySelector(".content-selection").classList.contains("show")){
                    element.querySelector(".content-selection").classList.remove("show");
                }
            }
        });

        let indexSelectConseil = 0;
        let maxIndexSelectConseil = document.querySelectorAll(".content-conseils .conseil").length - 1;

        document.querySelectorAll(".content-conseils .conseil").forEach((conseil, index) => {
            conseil.addEventListener("click", () => {
                indexSelectConseil = index;
                document.querySelector(".content-conseils .conseil.active").classList.remove("active");
                conseil.classList.add("active");
                let content = conseil.getAttribute("data-conseil-content"); 
                document.querySelector(".content-conseils .conseil-description").innerHTML = content;
            });
        });  

        document.querySelector(".content-conseils .control-right").addEventListener("click", () => {
            indexSelectConseil++;
            if(indexSelectConseil > maxIndexSelectConseil){
                indexSelectConseil = 0;
            }
            document.querySelector(".content-conseils .conseil.active").classList.remove("active");
            document.querySelectorAll(".content-conseils .conseil")[indexSelectConseil].classList.add("active");
            let content = document.querySelectorAll(".content-conseils .conseil")[indexSelectConseil].getAttribute("data-conseil-content"); 
            document.querySelector(".content-conseils .conseil-description").innerHTML = content;
        });

        document.querySelector(".content-conseils .control-left").addEventListener("click", () => {
            indexSelectConseil--;
            if(indexSelectConseil < 0){
                indexSelectConseil = maxIndexSelectConseil;
            }
            document.querySelector(".content-conseils .conseil.active").classList.remove("active");
            document.querySelectorAll(".content-conseils .conseil")[indexSelectConseil].classList.add("active");
            let content = document.querySelectorAll(".content-conseils .conseil")[indexSelectConseil].getAttribute("data-conseil-content"); 
            document.querySelector(".content-conseils .conseil-description").innerHTML = content;
        });

        //document.querySelectorAll(".cta.goto")
    }   

    async getProfil(preoccupation, peau){
        console.log("preoccupation", preoccupation);
        console.log("peau", peau);
        const config = {
            method : 'POST',
            body: JSON.stringify({preoccupation, peau})
        }
        const call = await fetch(`${app.aws.url}/diag/preoccupation`, config);
        const profil = await call.json(); 
        this.buildPrd(profil, "matin");
        this.buildPrd(profil, "soir");
        this.buildPrd(profil, "complements"); 
        this.buildProfil(profil);
        this.buildEventFilter();
        this.buildEventSelection();
    } 

    select(target){  
        const type = target.getAttribute("data-type");
        const value = target.getAttribute("data-value");
        if(target.closest(".content-select").querySelector(".btn.active") != null){
            target.closest(".content-select").querySelector(".btn.active").classList.remove("active");
        }
        target.classList.add("active");
        target.closest(".content-selector").classList.add("ok");
        this.options[type] = value;
        if(type == "preoccupation"){
            const checkSkin = (/true/).test(target.getAttribute("data-filtrer-skin")); 
            this.options.preo_desc = target.getAttribute("data-title-desc");
            this.options.peau = ""; 
            //document.querySelector(".title-preo-q").innerHTML = this.options.preo_desc;
            document.querySelector(".title-preo-p").innerHTML = this.remplacerArticles(this.options.preo_desc); 
            if(checkSkin){
                this.currentStep = 2; 
                this.hideStep(3);
                this.goToStep(this.currentStep);
            }else{
                this.currentStep = 3;
                this.hideStep(2); 
                this.getProfil(this.options.preoccupation, this.options.peau);
                this.goToStep(this.currentStep);
            } 
        }else{
            this.currentStep = 3; 
            this.getProfil(this.options.preoccupation, this.options.peau); 
            this.goToStep(this.currentStep);
        }   
    }

    remplacerArticles(texte) {
        // Dictionnaire de remplacement

        console.log(texte);
        const remplacements = {
            "Le": "un",
            "La": "une",
            "Les": "des",
        };
    
        // Fonction de remplacement
        for (const [ancien, nouveau] of Object.entries(remplacements)) {
            const regex = new RegExp('\\b' + ancien + '\\b', 'g');
            texte = texte.replace(regex, nouveau);
        }
    
        return texte.toLowerCase();
    }

    goToStep(index){  
        document.querySelectorAll(`[data-step="${index}"]`).forEach(step => {
            step.classList.remove("hide");
        });
        let targetScroll = document.querySelectorAll(`[data-step="${index}"]`)[0].offsetTop - 100;
        window.scroll(0, targetScroll);
    }

    hideStep(index, slow, waiting){
        document.querySelectorAll(`[data-step="${index}"]`).forEach(step => {
            if(slow){
                setTimeout(() => {
                    step.classList.add("hide-slow");
                }, waiting);
            }else{
                step.classList.add("hide");
            } 
        });
    }

    resetStep(index){
        document.querySelectorAll(`[data-step="${index}"]`).forEach(step => { 
            step.classList.add("hide"); 
            step.classList.remove("ok"); 
        });
    }

    splitParagraph(paragraph) { 
        let nbWord = 30;
        let split = paragraph.replace("\n", "").replace(/\s+/g, ' ').trim().split(" ");
        let firstSentence = "";
        console.log(split);
        for(let i = 0; i <= nbWord; i++){
            if(split[i].indexOf("<br><br>") != -1){
                i = nbWord;
            }else{
                firstSentence += split[i] + " "; 
            }
        }
        return {
            firstSentence: firstSentence,
            remainingText: paragraph.replace("\n", "").replace(/\s+/g, ' ').trim().replace(firstSentence, "")
        };
    }

    switchLabelPeau(id){
        switch(id){
            case "peau-mixte-normale" : return "une peau mixte à normale"; 
            case "peau-grasse": return "une peau grasse"; 
            case "peau-seche": return "une peau sèche";
            default: return "";
        }
    }

    buildProfil(profil){ 
        console.log(profil);
        
        let titleConseil = `Vous avez ${this.remplacerArticles(this.options.preo_desc)}`;
        if(this.options.peau != ""){
            titleConseil += ` et ${this.switchLabelPeau(this.options.peau)}`;
        }
        document.querySelector(".content-descriptions .title h2 .t1").innerHTML = titleConseil;

        document.querySelector(".content-conseils h2").innerHTML = profil.recommandations.title;
 
        console.log(Object.entries(profil.infos));
        Object.entries(profil.infos).forEach((info, index) => {  
            const splitP = this.splitParagraph(info[1].content);
            document.querySelectorAll(".content-descriptions .descriptions .description")[index].querySelector("h3").innerHTML = info[1].title;
            document.querySelectorAll(".content-descriptions .descriptions .description")[index].querySelector(".d-show").innerHTML = splitP.firstSentence; 
            document.querySelectorAll(".content-descriptions .descriptions .description")[index].querySelector(".d-hide").innerHTML = splitP.remainingText; 
        });
        document.querySelector(".content-infos-produits .texte").innerHTML = profil.produits_infos.content;
        document.querySelectorAll(".content-conseils .conseil").forEach(conseil => {
            let id = conseil.getAttribute("data-conseil");
            let contentProfilConseilS = profil.conseils[id];
            //conseil.querySelector(".texte h3").innerHTML = contentProfilConseilS[0]; 
            conseil.setAttribute("data-conseil-content", contentProfilConseilS);
        }); 
        let idConseil1 = document.querySelectorAll(".content-conseils .conseil")[0].getAttribute("data-conseil-content");
        document.querySelector(".content-conseils .conseil-description").innerHTML = idConseil1;
    }

    buildPrd(profil, cat){ 

        this.recos.querySelector(`.${cat} .prds`).innerHTML = "";

        if(profil.products[cat].length > 0){
            profil.products[cat].forEach((prd, index) => {  
    
                if(this.options.products[prd.handle].available){
                    if(this.options.products[prd.handle].price < this.options.products[prd.handle].compare_at_price){
                        var price = `<div class="price"><span class="oldprice">${this.options.products[prd.handle].old_price}</span><span style="color: ${this.options.products[prd.handle].color};" class="currentprice">${this.options.products[prd.handle].current_price}</span></div>`;
                    }else{
                        var price = `<div class="price"> 
                            <span class="currentprice">
                                ${this.options.products[prd.handle].current_price}
                            </span>
                        </div>`;
                    }
                    var atc = ` 
                        <div class="infos-add-to-cart" data-vid="${this.options.products[prd.handle].vid}" data-price="${this.options.products[prd.handle].price}"> 
                            ${price}
                            <div class="infos">
                                <div class="label">
                                    <div class="off">
                                        <span>Ajouter +</span>
                                    </div>
                                    <div class="on">
                                        <span class="on">Ajouté</span> 
                                        <div class="check"> 
                                            <svg version="1.1" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
                                                <path d="M16,8c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8S16,3.6,16,8z M12,5c-0.3-0.3-0.8-0.3-1.1,0c0,0,0,0,0,0L7.5,9.4L5.4,7.3
                                                C5.1,7,4.6,7.1,4.3,7.4c-0.3,0.3-0.3,0.7,0,1L7,11c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0l4-5C12.3,5.7,12.3,5.3,12,5L12,5z"/>
                                            </svg> 
                                        </div>
                                    </div> 
                                </div>  
                            </div>  
                        </div>  
                    `;
                }else{
                    var atc = `<div class="out-of-stock"> 
                        <div class="infos">
                            <div class="label">
                                Rupture de stock
                            </div>
                        </div>
                    </div>`; 
                }

                let besoins = this.createElementWithClass("div", ["content-besoin"]); 
                let tags = this.options.products[prd.handle].besoins.split(",");

                tags.forEach(tag => {
                    if(tag != ""){ 
                        let besoin = this.createElementWithClass("div", ["besoin"]);
                        besoin.style.background = this.options.products[prd.handle].color;
                        besoin.innerHTML = tag;
                        besoins.appendChild(besoin);
                    }
                });

                let productType = this.createElementWithClass("div", ["besoin"]);
                productType.style.background = this.options.products[prd.handle].color;
                productType.innerHTML = this.options.products[prd.handle].type;
                besoins.appendChild(productType); 

                let contentProduct = this.createElementWithClass("div", ["product-min", `product-${this.options.products[prd.handle].id}`]);
                contentProduct.setAttribute("data-handle", prd.handle);
                contentProduct.setAttribute("data-cat", cat);
                contentProduct.setAttribute("data-vid", this.options.products[prd.handle].vid);


                //let pictosHtml = `<div class="tags">`; 
                let pictosHtml = "";
                /*
                if(cat == "matin"){
                    contentProduct.classList.add("matin");
                    pictosHtml += `<div class="picto matin">
                                        <svg version="1.1"  x="0px" y="0px" viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve">
                                            <path d="M5,7.5c1.4,0,2.5-1.1,2.5-2.5S6.4,2.5,5,2.5S2.5,3.6,2.5,5S3.6,7.5,5,7.5z M5,0c0.2,0,0.3,0.1,0.3,0.3v1.2
                                            c0,0.2-0.1,0.3-0.3,0.3S4.7,1.7,4.7,1.6V0.3C4.7,0.1,4.8,0,5,0z M5,8.1c0.2,0,0.3,0.1,0.3,0.3v1.2C5.3,9.9,5.2,10,5,10
                                            S4.7,9.9,4.7,9.7V8.4C4.7,8.3,4.8,8.1,5,8.1z M10,5c0,0.2-0.1,0.3-0.3,0.3H8.4C8.3,5.3,8.1,5.2,8.1,5s0.1-0.3,0.3-0.3h1.2
                                            C9.9,4.7,10,4.8,10,5z M1.9,5c0,0.2-0.1,0.3-0.3,0.3H0.3C0.1,5.3,0,5.2,0,5s0.1-0.3,0.3-0.3h1.2C1.7,4.7,1.9,4.8,1.9,5z M8.5,1.5
                                            c0.1,0.1,0.1,0.3,0,0.4L7.7,2.8c-0.1,0.1-0.3,0.1-0.4,0s-0.1-0.3,0-0.4l0.9-0.9C8.2,1.3,8.4,1.3,8.5,1.5 M2.8,7.2
                                            c0.1,0.1,0.1,0.3,0,0.4L1.9,8.5c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.1-0.3,0-0.4l0.9-0.9C2.5,7.1,2.7,7.1,2.8,7.2 M8.5,8.5
                                            c-0.1,0.1-0.3,0.1-0.4,0L7.2,7.7c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0l0.9,0.9C8.6,8.2,8.6,8.4,8.5,8.5 M2.8,2.8
                                            c-0.1,0.1-0.3,0.1-0.4,0L1.5,1.9c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0c0,0,0,0,0,0l0.9,0.9C2.9,2.5,2.9,2.7,2.8,2.8"/>
                                        </svg>
                                    </div>`;
                }
                if(cat == "soir"){
                    contentProduct.classList.add("soir");
                    pictosHtml += `<div class="picto soir">
                                    <svg version="1.1"  x="0px" y="0px" viewBox="0 0 7 8.5" style="enable-background:new 0 0 7 8.5;" xml:space="preserve">
                                        <path class="st0" d="M2.8,0.3c0.1,0.1,0.1,0.3,0,0.4C2.6,1.2,2.4,1.9,2.4,2.5c0,2.1,1.5,3.7,3.4,3.7c0.2,0,0.5,0,0.7-0.1
                                            c0.1,0,0.3,0,0.4,0.2C7,6.4,7,6.6,6.9,6.8c-0.7,1-1.9,1.6-3,1.6C1.7,8.3,0,6.4,0,4.1c0-1.8,1-3.3,2.4-3.9C2.5,0.1,2.7,0.1,2.8,0.3z"
                                            />
                                    </svg>
                                </div>`;
                } 
                */

                if(prd.essentiel){
                    contentProduct.classList.add("essentiel");
                    pictosHtml += `<div class="picto essentiel">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 9 8" style="enable-background:new 0 0 9 8;" xml:space="preserve">
                                            <path class="st0" d="M4.3,6.3L2.5,7.2v0L2.2,7.3l0.4-2.1l0.1-0.3L2.4,4.8L0.8,3.3L3.1,3l0.3,0l0.1-0.2l1.1-2l1,2l0.1,0.2l0.3,0
                                            l2.3,0.3L6.6,4.8L6.4,5l0.1,0.3l0.4,2.1l-2.1-1L4.5,6.2L4.3,6.3z M8.6,3L8.6,3L8.6,3L8.6,3z"/>
                                        </svg>
                                    </div>`;
                }
                //pictosHtml += `</div>`;

                let step = "";
                if(cat != "complements"){

                    let picto = "";
                    if(cat == "matin"){
                        contentProduct.classList.add("matin");
                        picto = `<div class="picto matin"> 
                                   <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
                                        <path d="M15.5,7.5h-2c-0.1,0-0.1,0-0.2,0c-0.1-1.1-0.5-2.2-1.2-3c0.1,0,0.1-0.1,0.2-0.1L13.7,3c0.2-0.2,0.2-0.5,0-0.7
                                            c-0.2-0.2-0.5-0.2-0.7,0l-1.4,1.4c0,0-0.1,0.1-0.1,0.2c-0.8-0.7-1.8-1.1-3-1.2c0-0.1,0-0.1,0-0.2v-2C8.5,0.2,8.3,0,8,0
                                            S7.5,0.2,7.5,0.5v2c0,0.1,0,0.1,0,0.2c-1.1,0.1-2.2,0.5-3,1.2c0-0.1-0.1-0.1-0.1-0.2L3,2.3c0,0,0,0,0,0c-0.2-0.2-0.5-0.2-0.7,0
                                            C2.1,2.5,2.1,2.9,2.3,3l1.4,1.4c0,0,0.1,0.1,0.2,0.1c-0.7,0.8-1.1,1.8-1.2,3c-0.1,0-0.1,0-0.2,0h-2C0.2,7.5,0,7.7,0,8
                                            s0.2,0.5,0.5,0.5h2c0.1,0,0.1,0,0.2,0c0.1,1.1,0.5,2.2,1.2,3c-0.1,0-0.1,0.1-0.2,0.1L2.3,13c-0.2,0.2-0.2,0.5,0,0.7
                                            c0.2,0.2,0.5,0.2,0.7,0l1.4-1.4c0,0,0.1-0.1,0.1-0.2c0.8,0.7,1.8,1.1,3,1.2c0,0.1,0,0.1,0,0.2v2C7.5,15.8,7.7,16,8,16
                                            s0.5-0.2,0.5-0.5v-2c0-0.1,0-0.1,0-0.2c1.1-0.1,2.2-0.5,3-1.2c0,0.1,0.1,0.1,0.1,0.2l1.4,1.4c0.2,0.2,0.5,0.2,0.7,0
                                            c0.2-0.2,0.2-0.5,0-0.7l-1.4-1.4c0,0-0.1-0.1-0.2-0.1c0.7-0.8,1.1-1.8,1.2-3c0.1,0,0.1,0,0.2,0h2C15.8,8.5,16,8.3,16,8
                                            S15.8,7.5,15.5,7.5z"/>
                                    </svg>
                                </div>`;
                    }
                    if(cat == "soir"){
                        contentProduct.classList.add("soir");
                        picto = `<div class="picto soir">
                                    <svg version="1.1"  x="0px" y="0px" viewBox="0 0 7 8.5" style="enable-background:new 0 0 7 8.5;" xml:space="preserve">
                                        <path class="st0" d="M2.8,0.3c0.1,0.1,0.1,0.3,0,0.4C2.6,1.2,2.4,1.9,2.4,2.5c0,2.1,1.5,3.7,3.4,3.7c0.2,0,0.5,0,0.7-0.1
                                            c0.1,0,0.3,0,0.4,0.2C7,6.4,7,6.6,6.9,6.8c-0.7,1-1.9,1.6-3,1.6C1.7,8.3,0,6.4,0,4.1c0-1.8,1-3.3,2.4-3.9C2.5,0.1,2.7,0.1,2.8,0.3z"
                                            />
                                    </svg>
                                </div>`;
                    } 

                    step = `
                        <div class="content-step-routine">
                            <div class="step-routine">
                                Etape 
                                <div class="content-icone-number">
                                    <span class="number ${cat}">${prd.step}</span>
                                    ${picto}
                                </div>
                            </div>
                        </div>
                    `;
                }
                
                let dataProduct = `   
                    <div class="content-main">  
                        ${step} 
                        <div class="left">
                            <div class="content-img-prd"> 
                                <img  
                                    src="${this.options.products[prd.handle].img_png}" 
                                    data-full="${this.options.products[prd.handle].img_png}" 
                                />   
                            </div>
                        </div>
                        <div class="right">
                            <div class="content-infos-prd"> 
                                ${besoins.outerHTML}
                                <h3>
                                    ${this.options.products[prd.handle].title}
                                    ${pictosHtml}
                                </h3>   
                                ${this.options.products[prd.handle].benefice} 
                            </div>  
                            <div class="content-add-to-cart"> 
                                ${atc}
                            </div> 
                        </div>
                    </div>
                `; 

                contentProduct.innerHTML = dataProduct;
                this.recos.querySelector(`.${cat} .prds`).appendChild(contentProduct);

            });
        }else{
            this.recos.querySelector(`.${cat}`).classList.add("hide");
        }
 
        
    }

    buildEventSelection(){
        this.recos.querySelectorAll(".product-min").forEach(prd => {
            prd.addEventListener("click", () => {
                if(!prd.classList.contains("selected")){
                    let handle = prd.getAttribute("data-handle");
                    let cat = prd.getAttribute("data-cat");
                    this.productsSelected.push({
                        vid: this.options.products[handle].vid,
                        handle: handle,
                        price: this.options.products[handle].price,
                        cat: cat
                    }); 
                    this.recos.querySelectorAll(`.product-min[data-handle='${handle}'][data-cat='${cat}']`).forEach(p => {p.classList.add("selected")});
                    //this.recos.querySelectorAll(`.product-min[data-handle='${handle}']`).forEach(p => {p.classList.add("selected")});
                    this.buildSelection(this.productsSelected);
                }else{
                    let handle = prd.getAttribute("data-handle");
                    let cat = prd.getAttribute("data-cat");
                    this.recos.querySelectorAll(`.product-min[data-handle='${handle}'][data-cat='${cat}']`).forEach(p => {p.classList.remove("selected")});
                    //this.recos.querySelectorAll(`.product-min[data-handle='${handle}']`).forEach(p => {p.classList.remove("selected")});
                    let dataVid = prd.getAttribute("data-vid");  
                    if(dataVid != null && dataVid != ""){ 
                        const indexToRemove = this.productsSelected.findIndex(prd => prd.vid === parseInt(dataVid) && prd.cat === cat);
                        //const indexToRemove = this.productsSelected.findIndex(prd => prd.vid === parseInt(dataVid));
                        if (indexToRemove !== -1) {
                            this.productsSelected.splice(indexToRemove, 1);
                        }
                    }  
                    this.buildSelection(this.productsSelected); 
                }
            });
        }); 
    }

    buildEventFilter(){
        this.filters.forEach(filter => {
            filter.addEventListener("click", () => {
                let dataFilter = filter.getAttribute("data-filter");
                this.diag.querySelector(".content-filter .filter.active").classList.remove("active");
                filter.classList.add("active");
                if(dataFilter != "all"){
                    this.recos.querySelectorAll(".product-min").forEach(prd => {
                        if(prd.classList.contains(dataFilter)){
                            if(prd.classList.contains("hide")){
                                prd.classList.remove("hide");
                            }
                        }else{
                            prd.classList.add("hide");
                        }
                    });
                }else{
                    this.recos.querySelectorAll(".product-min").forEach(prd => { 
                        if(prd.classList.contains("hide")){
                            prd.classList.remove("hide");
                        } 
                    });
                }
            });
        });
    }
 

    buildSelection(selectionsProducts){
        let totalPrice = 0;
        this.selections.forEach((selection, index) => {
            if(typeof selectionsProducts[index] != "undefined"){
                let title = this.options.products[selectionsProducts[index].handle].title;
                selection.querySelector(".content-image").innerHTML = `<img src="${this.options.products[selectionsProducts[index].handle].img_png}" />`;
                if(this.options.products[selectionsProducts[index].handle].contenance != "Default Title"){
                    selection.querySelector(".content-desc h3").innerHTML = `<span class="label">${title}</span><br><span class="contenance">${this.options.products[selectionsProducts[index].handle].contenance}</span>`;
                }else{
                    selection.querySelector(".content-desc h3").innerHTML = `<span class="label">${title}</span>`;
                }
                selection.setAttribute("data-vid", selectionsProducts[index].vid);
                selection.setAttribute("data-cat", selectionsProducts[index].cat);
                selection.classList.add("selected");
                totalPrice += selectionsProducts[index].price;
            }else{ 
                selection.querySelector(".content-image").innerHTML = "";
                selection.querySelector(".content-desc h3").innerHTML = "";
                selection.setAttribute("data-vid", "");
                selection.setAttribute("data-cat", "");
                if(selection.classList.contains("selected")){
                    selection.classList.remove("selected");
                }
            }
        });   
        if(selectionsProducts.length < this.options.selectionMax){
            if(this.diffContent.classList.contains("success")){
                this.diffContent.classList.remove("success");
            }
            this.countSelection.innerHTML = this.diffProductSelect(selectionsProducts.length);
            this.addToCart.querySelector(".price .currentprice").innerHTML = this.formatPrice(totalPrice);
            this.addToCart.querySelector(".price .oldprice").innerHTML = "";
        }else{
            if(!this.diffContent.classList.contains("success")){
                this.diffContent.classList.add("success");
            }
            this.countSelection.innerHTML = "0";
            if(this.options.offer){ 
                let discount = totalPrice * 0.85;
                this.addToCart.querySelector(".price .currentprice").innerHTML = this.formatPrice(discount);
                this.addToCart.querySelector(".price .oldprice").innerHTML = this.formatPrice(totalPrice);
            }else{
                this.addToCart.querySelector(".price .currentprice").innerHTML = this.formatPrice(totalPrice);
                this.addToCart.querySelector(".price .oldprice").innerHTML = "";
            }
        } 
    }

    /*
    buildSelection(selectionsProducts){
        let totalPrice = 0;
        this.selections.forEach((selection, index) => {
            if(typeof selectionsProducts[index] != "undefined"){
                selection.querySelector(".content-image").innerHTML = `<img src="${this.options.products[selectionsProducts[index].handle].img0.full}" />`;
                selection.setAttribute("data-vid", selectionsProducts[index].vid);
                totalPrice += selectionsProducts[index].price;
            }else{
                selection.querySelector(".content-image").innerHTML = "";
                selection.setAttribute("data-vid", "");
            }
        });  
        this.countSelection.innerHTML = this.diffProductSelect(selectionsProducts.length);
        if(selectionsProducts.length < this.options.selectionMax){
            this.addToCart.querySelector(".price .currentprice").innerHTML = this.formatPrice(totalPrice);
            this.addToCart.querySelector(".price .oldprice").innerHTML = "";
        }else{
            let discount = totalPrice * 0.9;
            this.addToCart.querySelector(".price .currentprice").innerHTML = this.formatPrice(discount);
            this.addToCart.querySelector(".price .oldprice").innerHTML = this.formatPrice(totalPrice);
        } 
    }*/

    diffProductSelect(number){
        return this.options.selectionMax - number;
    }

    formatPrice(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (price / 100).toFixed(2) + devise;
    }

    createElementWithClass(type, className = []){
        var element = document.createElement(type);
        className.forEach(cn => {
            element.classList.add(cn);
        }); 
        return element; 
    }

    get stateSlider(){
        return window.innerWidth >= 992 || document.querySelector('#preoccupations').classList.contains("ok") && window.innerWidth < 992;
    }

}  